import { chakra, forwardRef, ThemingProps, omitThemingProps, useStyleConfig, HTMLChakraProps } from '@chakra-ui/react';
import { __DEV__ } from '@chakra-ui/utils';

export interface IOverlayProps extends HTMLChakraProps<'div'>, ThemingProps {}

export const Overlay = forwardRef<IOverlayProps, 'div'>(function Overlay(props, ref) {
  const styles = useStyleConfig('Overlay', props);

  const {
    // extract components props here
    ...rest
  } = omitThemingProps(props);

  return <chakra.div ref={ref} __css={styles} {...rest} />;
});

if (__DEV__) {
  Overlay.displayName = 'Overlay';
}
